import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * Consistent page header used across app screens.
 * Renders an accent-gradient title, optional subtitle, and right-aligned actions.
 */
export default function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'flex-end' },
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
        mb: 4,
      }}
    >
      <Box>
        <Typography
          className="font-display"
          sx={{
            fontWeight: 800,
            fontSize: { xs: '1.75rem', md: '2.125rem' },
            lineHeight: 1.1,
            letterSpacing: '-0.03em',
            background: 'linear-gradient(96deg, var(--color-primary), var(--color-accent))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="body2"
            sx={{ color: 'var(--color-muted)', mt: 0.75, maxWidth: 560 }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
          {actions}
        </Box>
      )}
    </Box>
  );
}
